const effortless = callback => Promise.resolve().then(() => callback());

export {
	effortless,
};
